<template>
  <div id="modelFilterList">
    <div class="shown-toolbar form-group">
      <label class="control-label sr-only">URL Builder</label>
      <textarea id="url-builder" @focus="selectUrl()" class="form-control" :value="urlBuilder"></textarea>
    </div>

    <div id="filter-toggle" class="d-block d-md-none toggle-filters margin-bottom"><a @click="toggleFilters()" class="btn-orange">Open Filters</a></div>

    <div id="search-filters-wrapper" class="search-filters">
      <fieldset class="model-filter-wrapper industry-list-wrapper" v-if="industryOptions && industryOptions.length">
        <legend>Filter By Industry</legend>
        <div class="industry-options options-wrapper">
          <div v-for="(option) in industryOptions" :key="option.id" class="option">
            <label>
              <input type="checkbox" v-model="searchIndustryFilter" :value="option.id" />
              {{ option.name }}
            </label>
          </div>
        </div>
      </fieldset>

      <fieldset class="model-filter-wrapper size-list-wrapper" v-if="sizeOptions && sizeOptions.length">
        <legend>Filter By Size</legend>
        <div class="size-options options-wrapper">
          <div v-for="(option) in sizeOptions" :key="option.id" class="option">
            <label>
              <input type="checkbox" v-model="searchSizeFilter" :value="option.id" />
              {{ option.name }}
            </label>
          </div>
        </div>
      </fieldset>

      <fieldset class="model-filter-wrapper cf-list-wrapper" v-if="cfOptions && cfOptions.length">
        <legend>Filter By Cubic Feet Per Hour</legend>
        <div class="cf-options options-wrapper">
          <div v-for="(option) in cfOptions" :key="option.id" class="option">
            <label>
              <input type="checkbox" v-model="searchCfFilter" :value="option.id" />
              {{ option.name }}
            </label>
          </div>
        </div>
      </fieldset>

      <fieldset class="model-filter-wrapper outlet_pressure_range-list-wrapper" v-if="outletPressureRangeOptions && outletPressureRangeOptions.length">
        <legend>Filter By Outlet Pressure Range</legend>
        <div class="outlet_pressure_range-options options-wrapper">
          <div v-for="(option) in outletPressureRangeOptions" :key="option.id" class="option">
            <label>
              <input type="checkbox" v-model="searchOutletPressureRangeFilter" :value="option.id" />
              {{ option.name }}
            </label>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
import { useModelWrapper } from '@/utils/modelWrapper'

export default {
  name: 'SearchFilters',
  props: {
    industryFilter: Array,
    sizeFilter: Array,
    cfFilter: Array,
    outletPressureRangeFilter: Array,
    industryOptions: Array,
    sizeOptions: Array,
    cfOptions: Array,
    outletPressureRangeOptions: Array,
    urlBuilder: String
  },
  setup (props, { emit }) {
    return {
      searchIndustryFilter: useModelWrapper(props, emit, 'industryFilter'),
      searchSizeFilter: useModelWrapper(props, emit, 'sizeFilter'),
      searchCfFilter: useModelWrapper(props, emit, 'cfFilter'),
      searchOutletPressureRangeFilter: useModelWrapper(props, emit, 'outletPressureRangeFilter')
    }
  },
  methods: {
    toggleFilters: function () {
      var button = document.getElementById('filter-toggle').getElementsByClassName('btn-orange')[0]
      var filters = document.getElementById('search-filters-wrapper')
      if (button.innerHTML === 'Open Filters') {
        button.innerHTML = 'Close Filters'
        filters.style.height = filters.scrollHeight + 'px'
      } else {
        button.innerHTML = 'Open Filters'
        filters.style.height = '0px'
      }
    },
    selectUrl: function () {
      document.getElementById('url-builder').select()
    }
  }
}
</script>
